<template>
  <div class="py-4 candidate biography form">
    <v-layout class="pb-2 px-3" row wrap align-center justify-start>
      <div class="subheading">Introduce yourself</div>
      <div class="text-xs-left">
        <v-btn icon small @click="showHelp = !showHelp" :color="themes.candidate.light.mutedText">
          <v-icon>mdi-help-circle</v-icon>
        </v-btn>
      </div>

      <v-slide-y-transition>
        <v-flex
          v-show="showHelp"
          :class="themes.candidate.light.mutedText"
          class="text-xs-justify px-3"
          xs12
        >
          <pre
            style="white-space: pre-wrap; word-wrap: break-word; font-family: inherit;"
            v-text="helpText"
          />
        </v-flex>
      </v-slide-y-transition>
    </v-layout>

    <div class="px-3">
      <v-textarea
        v-model="biography"
        @input="submit"
        @blur="submit"
        :color="themes.candidate.light.input"
        :error-messages="errorMessages"
        :loading="loading"
        :rules="rules"
        hint="In order to be considered complete it should be at least 150 words or longer"
        ref="biography"
        auto-grow
        outline
        :placeholder="helpText"
      />
    </div>
  </div>
</template>

<script>
// Helpers
import { mapGetters } from 'vuex'
import _ from 'lodash'

// Vue Component
export default {
  props: { profile: { type: Object, required: true } },

  data() {
    return {
      // Toggles
      loading: false,
      showHelp: false,

      // Model
      biography: this.profile.biography || '',

      rules: [
        v => !v || (!!v && this.wordCount(v) >= 150) || 'atleast 150 words required',
        v => !v || (!!v && v.length < 2500) || 'up to 2500 characters allowed',
      ],

      helpText: `Your biography is essentially an overview of the information you already provided in other steps, but here you have more freedom to express yourself and give people a glimpse of who you are.\n
Your introduction will be the first thing organisations read when viewing your application. It is your key opportunity to make a positive first impression and entice the reader to want to know more. When organisations receive a lot of applications, it may be the ONLY thing they read about you - so grab their attention by making your story interesting and informative.\n
Highlight your academic, work, volunteering and life experiences and the skills you picked up along the way. Pick out the key achievements - things that immediately signal that you would excel at any task - and consider talking about your personal and professional (career) goals.\n
Remember: keep it punchy and don’t waffle! Include only relevant information, but take care to explain yourself clearly. And if you really want to differentiate yourself, avoid meaningless jargon and buzzwords like “go-getter” or “think outside of the box”.\n`,
    }
  },

  computed: {
    errorMessages() {
      if (_.get(this, 'biography.length') === 0) return []
      if (this.wordCount(this.biography) >= 150) return []

      return [`150 words required (currently  ${this.wordCount(this.biography)})`]
    },
  },

  methods: {
    wordCount(text) {
      if (typeof text !== 'string') return 0
      return ((text || '').match(/([a-zA-Z0-9_\-'’,.])+/gm) || []).length
    },

    submit: _.debounce(function() {
      if (this.biography !== this.profile.biography) {
        this.loading = true
        this.$store
          .dispatch('candidate/profile/update', { ...this.profile, biography: this.biography })
          .then(() => (this.loading = false))
      }
    }, 1000),
  },
}
</script>

<style>
.candidate.biography.form textarea {
  margin-top: 0;
}
</style>
